export const initEventsFilter = () => {
    // Initialize events filter without reset button
    setupEventsFilter(false);
};

export const setupEventsFilter = (showResetButton = true) => {
    const filterForm = document.getElementById('eventsFilter');

    if (!filterForm) {
        return;
    }

    // Handle form submission
    filterForm.addEventListener('submit', (e) => {
        e.preventDefault();

        // Find the container that holds everything - this is the key fix
        // Instead of just getting .events, we need to get the parent frame
        const eventsContainer = document.querySelector('.events');
        const frameContainer = eventsContainer.closest('.frame-list-type-hskoblenzevents_hskoblenzevents');

        // Submit the filter form using AJAX
        submitFilterForm(document.getElementById('eventsFilter'))
            .then((response) => {
                // Replace the entire frame HTML instead of just the events container
                // This prevents the nesting issue
                if (frameContainer) {
                    // Extract just the inner content from the response
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = response;

                    // Find the events container in the response
                    const newEventsContainer = tempDiv.querySelector('.events');

                    if (newEventsContainer) {
                        // Replace just the events part
                        eventsContainer.innerHTML = newEventsContainer.innerHTML;
                        // Re-initialize the filter
                        setupEventsFilter();
                    } else {
                        eventsContainer.innerHTML = 'Es ist ein Fehler aufgetreten.';
                    }
                } else if (eventsContainer) {
                    // Fallback if we can't find the frame container
                    eventsContainer.innerHTML = 'Es ist ein Fehler aufgetreten.';
                }
            })
            .catch(() => {
                // Check if eventsContainer exists before trying to set innerHTML
                if (eventsContainer) {
                    eventsContainer.innerHTML = 'Es ist ein Fehler aufgetreten.';
                }
            });
    });

    // Initialize reset button if needed
    if (showResetButton) {
        const resetButton = filterForm.querySelector('.btn-reset');

        if (resetButton) {
            resetButton.classList.remove('d-none');

            // Handle form reset
            filterForm.addEventListener('reset', (e) => {
                e.preventDefault();

                // Find the same containers as in the submit handler
                const eventsContainer = document.querySelector('.events');
                const frameContainer = eventsContainer ? eventsContainer.closest('.frame-list-type-hskoblenzevents_hskoblenzevents') : null;

                if (!frameContainer) return;

                const xhr = new XMLHttpRequest();
                xhr.open('POST', filterForm.getAttribute('action'));
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        // Process the response similar to the submit handler
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = xhr.responseText;

                        const newEventsContainer = tempDiv.querySelector('.events');

                        if (newEventsContainer && eventsContainer) {
                            eventsContainer.innerHTML = newEventsContainer.innerHTML;
                            initEventsFilter();
                        }
                    }
                };
                xhr.send('');
            });
        }
    }
};

// Helper function to submit form data via AJAX
const submitFilterForm = (form) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData(form);
        const xhr = new XMLHttpRequest();

        xhr.open('POST', form.getAttribute('action'));
        xhr.onerror = reject;
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                resolve(xhr.responseText);
            }
        };
        xhr.send(formData);
    });
};
